import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Picture } from './'

import { PushContentStyle, LinkButtonPush } from './../styles'

export default class PushContent extends Component {
  render() {
    const { picture, title, page, label, description } = this.props

    return (
      <div className={`push-content ${PushContentStyle(picture)}`}>
        <div className="push-content--picture">
          <div className="picture"></div>
        </div>
        <div className="push-content--desc">
          <h3>
            { title }
          </h3>
          { page && (<Link to={page || ''} className={LinkButtonPush} > { label } </Link> )}
          { description && ( <p>{ description }</p> )}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/PushContent.js